import React, { useEffect } from "react";

export default function StepTwo({ data, setData }) {
  useEffect(() => {
    if (!Array.isArray(data.guests)) {
      setData((prevData) => ({ ...prevData, guests: [""] }));
    }
  }, [data.guests, setData]);

  const handleGuestChange = (index, value) => {
    const updatedGuests = [...data.guests];
    updatedGuests[index] = value.trim();
    setData({ ...data, guests: updatedGuests });
  };

  const addGuest = () => {
    if (data.guests.some((g) => g.trim() === "")) return;
    setData({ ...data, guests: [...data.guests, ""] });
  };

  const removeGuest = (index) => {
    const updatedGuests = data.guests.filter((_, i) => i !== index);
    setData({ ...data, guests: updatedGuests });
  };

  return (
    <div>
      <h2 style={{ fontSize: "20px", marginBottom: "1rem" }}>Add Guests</h2>

      <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
        {data.guests.map((guest, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              background: "#f0f0f0",
              borderRadius: "12px",
              padding: "0.5rem 0.75rem",
            }}
          >
            <input
              type="text"
              placeholder={`Guest ${index + 1}`}
              value={guest}
              onChange={(e) => handleGuestChange(index, e.target.value)}
              style={{
                flex: 1,
                border: "none",
                background: "transparent",
                fontSize: "14px",
                outline: "none",
              }}
            />
            {data.guests.length > 1 && (
              <button
                onClick={() => removeGuest(index)}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "16px",
                  cursor: "pointer",
                  color: "red",
                  marginLeft: "0.5rem",
                }}
              >
                ✕
              </button>
            )}
          </div>
        ))}
      </div>

      <button
        onClick={addGuest}
        style={{
          marginTop: "1rem",
          background: "transparent",
          border: "1px solid #ccc",
          padding: "0.4rem 0.8rem",
          borderRadius: "8px",
          fontSize: "14px",
          cursor: "pointer",
        }}
      >
        + Add Guest
      </button>
    </div>
  );
}
